// Change 'no-js' class to 'js' on the html element
document.documentElement.className = document.documentElement.className.replace(/\bno-js\b/g, '') + 'js';

jQuery(function ($) {
	
	var lazyImages = $('img[data-src]');
	lazyImages.each(function(){
		$(this).attr('src', $(this).data('src') );
		$(this).attr('data-src', null);
	});
	
	$.fn.changeTag = function (newTag) {
		var q = this;
		this.each(function (i, el) {
			var h = "<" + el.outerHTML.replace(/(^<\w+|\w+>$)/g, newTag) + ">";
			try {
				el.outerHTML = h;
			} catch (e) { //elem not in dom
				q[i] = jQuery(h)[0];
			}
		});
		return this;
	};

	var lazyVideos = $('video datasrc');
	setTimeout(function(){
		lazyVideos.each(function(){
			$(this).changeTag("source").parent().get(0).play();
		});
	},1500);
    
    $('.template-product .gallery img').parent().zoom({
        magnify: 1.25,
    });
	
	//shtuff that happens on click//////////////////////////////////////////////////////////
	
	$('a[data-modal]').click(function(e){
		e.preventDefault();
		var target = $(this).data('modal');
		$('#modal-'+target).fadeIn();
		$('body').addClass('noScroll');
	});	
	
	$('a[href="#modal-signup"]').click(function(e){
		e.preventDefault();
		$('#modal-signup').fadeIn();
		$('body').addClass('noScroll');
	});
    
    
    // OPEN SEARCH BAR 
    $('a.search').click(function (e) {
        e.preventDefault();
        // console.log('search clicked');
//        $('body').addClass('noScroll');
        $('header .right').toggleClass('open-search');
        $('div.search-box').toggleClass('open-search');
		if( $(window).width() < 960 ){
			 $('div.search-box').css({'display': 'flex'}).hide().slideDown();
		}
    });

    // CLOSE SEARCH BAR
    $('.search-box a.close').click(function (e) {
        $('header .right').toggleClass('open-search');
        $('div.search-box').toggleClass('open-search');
	 	$('div.search-box').slideUp();
    });
	
	$('.product-upsell a.the-upsell').click(function(e){
		e.preventDefault();
		var thisID = $(this).data('target');
		console.log(thisID);
		$.ajax({
		   type: "post",
		   url: "/cart/update.js",
		   data: 'updates['+ thisID +']=1',
		   complete: function(jqXHR,response) {
			   if( jqXHR.status == 200){
				   location.reload(); 
				}else{
				   console.log('Somethihg went wrong ' + response);   
				}
		   }
		});
	});
	
	$('.quantity-selector a.quantity-controls').click(function(){
		var that = $(this).closest('article');
		var value = parseInt( $(this).siblings('input.qty-input').val() );
		if( $(this).hasClass('more') ){
			 value += 1;
			 $(this).closest('article').find('input.qty-input').val( value );
		}else{
			value -= 1;
			if( value <= 0 ){
				value = 1;	
			}
			$(this).closest('article').find('input.qty-input').val( value );
		}
		setTimeout(function(){
			if( value == parseInt( that.find('input.qty-input').val() ) ){
				$('#cart_update').trigger('click');
			}
		},250);
		
	});
	
	$('.template-cart .titles a.more').click(function(){
		var thisID = $(this).data('target');
		var bundle = $(this).data('bundle');
//		var bundle = '28742812893237';
		$.ajax({
		   type: "post",
		   url: "/cart/update.js",
		   data: 'updates['+ thisID +']=0&updates['+ bundle +']=1',
		   complete: function(jqXHR,response) {
			   if( jqXHR.status == 200){
				   location.reload(); 
				}else{
				   console.log('Somethihg went wrong ' + response);   
				}
		   }
		});
	});
	
	$('nav li.haslinks > a').click(function(e){
		if( $(window).width() < 960 ){
			e.preventDefault();
			var target = $(this);
			if( target.attr('href') != '#' && !target.hasClass('triggered') ){
				target.closest('li').find('ul').prepend('<li>'+target+'</li>');
				target.addClass('triggered');
			}
			target.closest('li').toggleClass('active').find('ul').slideToggle();
		}
	});
	
	$('a.load-video').click(function(){
		var video = $(this).data('target');
		$(this).closest('.positioner').append(video);
	});
	
	$('a.variant-toggle').click(function(){
		var target = $(this).data('target');
		$('a.variant-toggle').removeClass('active');
		$(this).addClass('active');
		$('select#productVariants').val(target);
		
		var variant = $('select#productVariants').val();
		var product = $('select#productVariants').data('product');
		var url = '/admin/variants/#' + variant + '.json';
		var title = '';
		var price;
		var compare;
		$.getJSON( '/products/'+ product +'.js', function( data ) {
			data.variants.forEach(function(product, index){
				if( product.id == variant ){
					price = product.price;
					compare = product.compare_at_price;
					title = product.title
				}
			});
		}).then(function(){
			var h1 = $('h1 span').text();
			$('h1').html( '<span class="title">'+h1+'</span> ' + title );
			$('#product-price .current').text( Shopify.formatMoney(price) );
//			$('#product-price .num').text( Shopify.formatMoney(compare - price) );
		});
		
		var sIndex = $('.slick-slide[data-variant='+ target +']').data('slick-index');
		$('.product-details .gallery').slick('slickGoTo',sIndex);
		
	});
	
	$('section.benefits .the-benefits nav li').click(function(){
		var target = $(this).data('target');
		$('section.benefits .the-benefits nav li').removeClass('active');
		$('section.benefits .the-benefits .benefit').removeClass('active');
		$(this).addClass('active');
		$('section.benefits .the-benefits .benefit#'+target).addClass('active');
	});
	
	$('section.benefits .the-benefits nav li').click(function(){
		var target = $(this).data('target');
		$('section.benefits .the-benefits nav li').removeClass('active');
		$('section.benefits .the-benefits .benefit').removeClass('active');
		$(this).addClass('active');
		$('section.benefits .the-benefits .benefit#'+target).addClass('active');
	});
	
	$('.faqs-archive .faq h3').click(function(){
		$(this).toggleClass('active');
		$(this).closest('.faq').toggleClass('active');
		$(this).parent().find('.content').slideToggle();
	});
	
	$('.tabs .tab h2').click(function(){
		$(this).closest('.tab').toggleClass('active');
		$(this).parent().find('.content').slideToggle();
	});
	
	$('.benefit.accordion a').click(function(){
		$(this).toggleClass('active');
		$(this).parent().find('.content').slideToggle();
		var trigger = $(this).text();
		if( trigger == 'Read More' ){
			$(this).text('Show Less');
		}else{
			$(this).text('Read More');
		}
	});
	
	$('header .ham-btn').click(function(){
		console.log('btn clicked');
		if( $(this).hasClass('active') ){
			$(this).toggleClass('active');
			$('header').toggleClass('active');
			$('header nav').slideToggle();
			$('body').toggleClass('noScroll');
		}else{
			$(this).toggleClass('active');
			$('header').toggleClass('active');
			$('header nav').slideToggle();
			$('body').toggleClass('noScroll');
		}
	});

	$('.content-slider .part .slider').slick({
		mobileFirst: true,
		infinite: true,
		dots: false,
		arrows: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		asNavFor: '.content-slider .part .slider',
	});
	
	$('.content-slider .slider-nav .slick-arrow').click(function(){
		if( $(this).hasClass('slick-next') ){
			$('.content-slider .part .slider').slick('slickNext');
		}else{
			$('.content-slider .part .slider').slick('slickPrev');
		}
	});
	
	$('section.ingredients a.ing-details').click(function(){
		var target = $(this).data('target');
		$('#'+target).fadeIn();
	});
	
	$('section.ingredients a.view').click(function(){
		
		$(this).closest('.ingredients').find('.the-rest').slideToggle({ start: function () { $(this).css({ display: "flex" }) } });
		
		if( $(this).text() == 'See More' ){
			$(this).text('See Less')
		}else{
			$(this).text('See More')
		}
	});
	
	$('.pdm-lightbox').on('click', function(e) {
		if (e.target == this) {
			$(this).fadeOut();
			$('body').removeClass('noScroll');
		}
	});
	
	$('.pdm-lightbox a.close').on('click', function(e) {
		$(this).closest('.pdm-lightbox').fadeOut();
		$('body').removeClass('noScroll');
	});
	
	$('.subscribe-form form').submit(function(e) {
		e.preventDefault();
		var that = $(this)
		var $errors = that.parent().find('.lil-errors');
		$.ajax({
			type: "GET", // GET & url for json slightly different
			url: "https://neulivenhealth.us12.list-manage.com/subscribe/post-json?c=?",
			data: $(this).serialize(),
			dataType: 'json',
			contentType: "application/json; charset=utf-8",
			error: function(err) {
				console.log("Could not connect to the registration server.");
			},
			success: function(data) {
				if (data.result != "success") {
					console.log('Something is wrong with mailchimp form');
					if (data.msg.indexOf("is already subscribed") >= 0) {
						var msg = '<p>Thank you! <br/>But this email address is already subscribed.</p>';
						$errors.empty();
						$errors.html(msg);
					}
					if (data.msg.indexOf("An email address must contain a single @") >= 0 || data.msg.indexOf("0 - Please enter a value") >= 0) {
						var error = "<p>Please enter a valid email address</p>"
						$errors.html(error);
					}
					console.log(data.msg);
				} else {
					console.log(data.msg);
					that.hide();
					$errors.empty();
					$errors.addClass('thanks');
					var error = "<p>Thank you for subcribing!</p>"
					$errors.html(error);
				}
			}
		});
	});
	
	
	//shtuff that happens on load//////////////////////////////////////////////////////////
	
	if( $('body').hasClass('template-product') ){
		var url = window.location.href;
		$('.product-cta a.btn').click(function(e){
			var target = $(this).attr('href');
//			if( url.indexOf(target) >= 0 ){
				e.preventDefault();
				$('html,body').animate({scrollTop: $('.product-details .container').offset().top},'slow');
//			}
		});
	}
	
	if( $('body').hasClass('template-blog') ){
		var url = window.location.href;
		if( url.indexOf('tagged') >= 0 ){
			console.log('in a tag');
			$('html,body').animate({scrollTop: $('.the-blog').offset().top},'slow');
		}
	}
	
	if( $('body').hasClass('template-product') ){
		$(window).resize(function(){
			if( $(window).width() > 960 ){
//				console.log($('.ingredient-slider a:nth-child(4) ~'));
				$('.ingredient-slider a:nth-child(4) ~').wrapAll("<div class='the-rest'></div>")
			}
		});
	}
	
	
	if( $('body').hasClass('template-page-faqs') ){
		var faqNav = '<nav class="pill-nav faq-nav"><ul><li><a class="active" data-target="All" href="javascript:;">All FAQs</a></li></ul></nav>'
		$('.faq-section').first().before(faqNav);
		
		var sections = [];
		$('section.faqs-archive').each(function(){
			sections.push( $(this).find('h2').text() );
		});
		$.each(sections, function(key,section){
			$('.faq-nav ul').append('<li><a data-target="'+section+'" href="javascript:;">'+section+'</a></li>');
//			console.log('<li>><a data-target="'+section+'" href="javascript:;">'+section+'</a></li>');
		});
		
		$('body').on('click', '.pill-nav a', function(){
			var target = $(this).data('target');
			if( target == 'All' ){
				$('.pill-nav a').removeClass('active');
				$(this).addClass('active');
				$('body').removeClass('filtered');
				$('.faqs-archive').removeClass('active');
			}else{
				$('.pill-nav a').removeClass('active');
				$(this).addClass('active');
				$('body').addClass('filtered');
				$('.faqs-archive').removeClass('active');
				$('[data-name="'+target+'"]').addClass('active');
			}
		});
		
	}
	
	$('.product-details .gallery').slick({
		dots: false,
		arrows: false,
		slidesToShow: 1,
		slidesToScroll: 1,
	});
	
	$('.product-details .gallery-nav').slick({
		dots: false,
		arrows: false,
		slidesToShow: 4,
		slidesToScroll: 2,
	});
    
    $('.product-details form').on('change','.rc_block input',function(){
        var price = $(this).next().find('.rc_price').text();
        $('#product-price .current').text(price);
    });
	
	$('.gallery-nav [data-slick-index]').click(function(e) {
		e.preventDefault();
		var slideno = $(this).data('slick-index');
		$('.product-details .gallery').slick('slickGoTo', slideno);
 	});
	
	$('.trustIcons ul').slick({
		autoplay: true,
		autoplaySpeed: 2000,
		speed: 2000,
		infinite: true,
		dots: false,
		arrows: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		mobileFirst: true,
		responsive: [
			{
			  breakpoint: 600,
			  settings:{
				  slidesToShow: 4,
			  }
			},
			{
			  breakpoint: 720,
			  settings:{
				  slidesToShow: 5,
			  }
			},
			{
			  breakpoint: 960,
			  settings:{
				  slidesToShow: 6,
			  }
			}
		]
	});

	$('.icon-row ul').slick({
		autoplay: true,
		autoplaySpeed: 2000,
		speed: 2000,
		mobileFirst: true,
		infinite: true,
		dots: false,
		arrows: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
			  breakpoint: 600,
			  settings:{
				  slidesToShow: 4,
			  }
			},
			{
			  breakpoint: 720,
			  settings:{
				  slidesToShow: 5,
			  }
			},
			{
			  breakpoint: 960,
			  settings:{
				  slidesToShow: 6,
			  }
			},
			{
			  breakpoint: 1200,
			  settings:{
				  slidesToShow: 7,
			  }
			}
		]
	});
	
	$('.latest-posts-slider').slick({
//		autoplay: true,
		autoplaySpeed: 4000,
		speed: 2000,
		mobileFirst: true,
		infinite: false,
		dots: false,
		arrows: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		responsive: [
			{
			  breakpoint: 500,
			  settings:{
				  slidesToShow: 1.5,
			  }
			},
			{
			  breakpoint: 720,
			  settings:{
				  slidesToShow:2,
			  }
			},
			{
			  breakpoint: 960,
			  settings:{
				  slidesToShow: 2.25,
			  }
			},
			{
			  breakpoint: 1100,
			  settings:{
				  slidesToShow: 2.75,
			  }
			},
			{
			  breakpoint: 1200,
			  settings:{
				  slidesToShow: 3,
			  }
			}
		]
	});
	
	$('.ingredient-slider').slick({
		autoplay: true,
		autoplaySpeed: 5000,
		speed: 1500,
		mobileFirst: true,
		infinite: true,
		arrows:false,
		dots: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		responsive: [
			{
			  breakpoint: 550,
			  settings:{
				  slidesToShow: 2,
			  }
			},
			{
			  breakpoint: 960,
			  settings: "unslick"
			}
		]
	});
	
	$('.testimonial-slider').slick({
		autoplay: true,
		autoplaySpeed: 5000,
		speed: 1500,
		mobileFirst: true,
		infinite: true,
		arrows:true,
		dots: false,
		slidesToShow: 1,
		slidesToScroll: 1,
	});
	
	$(window).trigger('resize');
	
});